// @ts-nocheck
import { useState, useEffect } from 'react';
import { getLocationUptime } from '../services/supabaseService';

const useLocationUptime = () => {
  const [locationPerformances, setLocationPerformances] = useState({
    best: [],
    worst: [],
  });

  useEffect(() => {
    const fetchUptimeData = async () => {
      try {
        const currentYear = new Date().getFullYear();
        const performances = await getLocationUptime(currentYear);

        setLocationPerformances(performances);
      } catch (error) {
        console.error("Failed to fetch location uptime data:", error);
      }
    };

    fetchUptimeData();
  }, []);

  return locationPerformances;
};

export default useLocationUptime;